import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { BasicModal, DefaultButton } from 'common/components';
import { WarningIcon } from 'common/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetUserOTP, showResetOtpSuccessModal } from '../../_redux';
import { staticStyles } from './style';

const TwoFactorAuthorization = ({
  id,
  user,
  profile,
  resetUserOTP,
  resetUserOTPIsLoading,
  showResetOtpSuccessModal,
  resetOTPIsSuccess,
}) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleConfirmModalToggle = () => {
    setIsConfirmModalOpen(isOpen => !isOpen);
  };

  const tfaTypesMessagesKeysMap = {
    totp: 'authAuthenticatorApp',
    email: 'authTwoStepEmail',
  };

  const tfaType = user?.tfaSettings?.type;

  useEffect(() => {
    if (resetOTPIsSuccess) {
      setIsConfirmModalOpen(false);
    }
  }, [resetOTPIsSuccess]);

  return (
    <div className="TwoFactorAuth">
      <FormattedMessage id="settingTwoFaTitle">
        {txt => <h2 className="TwoFactorAuth__title">{txt}</h2>}
      </FormattedMessage>
      {tfaTypesMessagesKeysMap[tfaType] && (
        <div className="TwoFactorAuth__type-wrapper">
          <FormattedMessage id="authAuthenticationMethod">
            {txt => <span className="TwoFactorAuth__type-title">{txt}:</span>}
          </FormattedMessage>
          <FormattedMessage id={tfaTypesMessagesKeysMap[tfaType]} />
        </div>
      )}
      {(profile.perms.resetOTP || profile.perms.managerResetOTP) && tfaType && (
        <DefaultButton textId="resetTwoFactorAuth" onClick={handleConfirmModalToggle} filled />
      )}

      {!tfaType && <FormattedMessage id="justTwoFactorAuthIsNotSet" />}

      <BasicModal
        captionId="resetTwoFactorConfirmation"
        isOpen={isConfirmModalOpen}
        onRequestClose={handleConfirmModalToggle}>
        <div className="TwoFactorAuth__reset-confirmation-wrapper">
          <div className="TwoFactorAuth__reset-confirmation-icon">
            <WarningIcon />
          </div>
          <FormattedMessage id="resetTwoFactorConfirmationText">
            {txt => <span className="TwoFactorAuth__reset-confirmation-text">{txt}</span>}
          </FormattedMessage>
        </div>
        <div className="TwoFactorAuth__reset-confirmation-buttons">
          <DefaultButton
            textId="justReset"
            onClick={() => {
              resetUserOTP(id);
            }}
            disabled={resetUserOTPIsLoading}
            loading={resetUserOTPIsLoading}
            filled
          />
          <DefaultButton textId="justClose" onClick={handleConfirmModalToggle} />
        </div>
      </BasicModal>

      <BasicModal
        captionId="resetTwoFactorAuthSuccess"
        isOpen={resetOTPIsSuccess}
        onRequestClose={() => showResetOtpSuccessModal(false)}>
        {resetOTPIsSuccess && (
          <div className="ResetTwoFactorAuthSuccess">
            <DefaultButton textId="justDone" butColor="success" onClick={() => showResetOtpSuccessModal(false)} />
          </div>
        )}
      </BasicModal>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

TwoFactorAuthorization.propTypes = {
  id: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  resetUserOTP: PropTypes.func.isRequired,
  resetUserOTPIsLoading: PropTypes.bool.isRequired,
  showResetOtpSuccessModal: PropTypes.func.isRequired,
  resetOTPIsSuccess: PropTypes.bool.isRequired,
};

export default compose(
  withRouter,
  connect(
    state => ({
      user: state.backoffice.users.user,
      profile: state.user.profile,
      resetUserOTPIsLoading: state.backoffice.users.resetUserOTPIsLoading,
      resetOTPIsSuccess: state.backoffice.users.resetOTPIsSuccess,
    }),
    {
      resetUserOTP: userId => resetUserOTP.request(userId),
      showResetOtpSuccessModal: isSuccess => showResetOtpSuccessModal(isSuccess),
    }
  )
)(TwoFactorAuthorization);

export { TwoFactorAuthorization };
